import { LocalDate } from "@js-joda/core";
import { ChronoUnit } from '@js-joda/core/'
import { gridNumberComparator } from '@mui/x-data-grid-pro';

const formatCurrency = (currency) => {
  return Number(currency).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
};

const formatCurrencyShort = (currency) => {
  return Math.round(Number(currency)).toLocaleString();
};

const formatPercentage = (percentage) => {
  return !percentage ? "0.00" : percentage.toFixed(2);
};

export const DATE_FORMAT = 'MM/DD/YYYY';

export const LOAN_STATUS_MAP = {
  'PERFORMING': 'Performing',
  'LATE_30_DAYS': '30 Days Late',
  'LATE_60_DAYS': '60 Days Late',
  'LATE_90_DAYS': '90 Days Late',
  'LOCKBOX_TRIGGERED': 'Lockbox Triggered',
  'DEFAULT': 'Default',
  'FORECLOSURE': 'Foreclosure',
  'PAID_OFF': 'Paid Off',
};

export const SECURITY_STATUS_MAP = {
  'PERFORMING': 'Performing',
  'LATE_30_DAYS': '30 Days Late',
  'LATE_60_DAYS': '60 Days Late',
  'LATE_90_DAYS': '90 Days Late',
  'LOCKBOX_TRIGGERED': 'Lockbox Triggered',
  'DEFAULT': 'Default',
  'FORECLOSURE': 'Foreclosure',
  'PAID_OFF': 'Paid Off',
};

export const PIPELINE_STATUS_MAP = {
  'NEW': 'New',
  'IN_PROGRESS': 'In Progress',
  'UNDERWRITING': 'Underwriting',
  'FUNDED': 'Funded',
  'CLOSED': 'Closed',
};

export const PROPERTY_TYPE_MAP = {
  'SINGLE_FAMILY': 'Single-Family',
  'MULTI_FAMILY': 'Multi-Family',
  'OFFICE': 'Office',
  'COMMERCIAL': 'Commercial',
  'INDUSTRIAL': 'Industrial',
  'RETAIL': 'Retail',
  'HOTEL': 'Hotel',
  'SPECIAL_PURPOSE': 'Special-Purpose',
  'OTHER': 'Other'
};

export const US_STATES_MAP = {
  'AL': 'Alabama',
  'AK': 'Alaska',
  'AZ': 'Arizona',
  'AR': 'Arkansas',
  'CA': 'California',
  'CO': 'Colorado',
  'CT': 'Connecticut',
  'DE': 'Delaware',
  'DC': 'District of Columbia',
  'FL': 'Florida',
  'GA': 'Georgia',
  'HI': 'Hawaii',
  'ID': 'Idaho',
  'IL': 'Illinois',
  'IN': 'Indiana',
  'IA': 'Iowa',
  'KS': 'Kansas',
  'KY': 'Kentucky',
  'LA': 'Louisiana',
  'ME': 'Maine',
  'MD': 'Maryland',
  'MA': 'Massachusetts',
  'MI': 'Michigan',
  'MN': 'Minnesota',
  'MS': 'Mississippi',
  'MO': 'Missouri',
  'MT': 'Montana',
  'NE': 'Nebraska',
  'NV': 'Nevada',
  'NH': 'New Hampshire',
  'NJ': 'New Jersey',
  'NM': 'New Mexico',
  'NY': 'New York',
  'NC': 'North Carolina',
  'ND': 'North Dakota',
  'OH': 'Ohio',
  'OK': 'Oklahoma',
  'OR': 'Oregon',
  'PA': 'Pennsylvania',
  'RI': 'Rhode Island',
  'SC': 'South Carolina',
  'SD': 'South Dakota',
  'TN': 'Tennessee',
  'TX': 'Texas',
  'UT': 'Utah',
  'VT': 'Vermont',
  'VA': 'Virginia',
  'WA': 'Washington',
  'WV': 'West Virginia',
  'WI': 'Wisconsin',
  'WY': 'Wyoming'
};

export const EMPTY_LOAN = {
  KDMRating: '',
  dealName: '',
  id: '',
  initialAmount: '',
  loanNumber: '',
  loanRate: '',
  loanStatus: '',
  loanTermMonths: '',
  ltv: '',
  maturityDate: '',
  memoUrl: '',
  msn: '',
  msnId: '',
  originationDate: '',
  pipelineStatus: '',
  prepayMonths: '',
  principalBalance: '',
  properties: [],
  ratings: [],
  sponsor: '',
  sponsorID: '',
  spread: '',
  tradeDate: '',
};

//Eddie and CPayret +++___+++___+++

function inactiveHSdeals(unixTime) {
  var unixts = unixTime.slice(0, -3); // slice cuts off the last 3 digits
  var myDate = new Date(unixts * 1000); //Converts to miliseconds

  var LocalDate = require("@js-joda/core").LocalDate; //Defines LocalDate component (like an import)
  //obtain an instance of LocalDate from a year, month, and dayOfMonth value
  var dealLastActivityDate = LocalDate.of((myDate.getFullYear()), (myDate.getMonth() + 1), (myDate.getDate()))
  var todayDate = LocalDate.now(); // LocalDate format of the date of today, system default time zone, example: 2016-02-23

  var differenceBetweenDates = dealLastActivityDate.until(todayDate, ChronoUnit.DAYS); // returns the distance in total days

  return differenceBetweenDates;
  // d.format(DateTimeFormatter.ofPattern('M/d/yyyy'))
}


/*
* Function that takes an epoch time in Milliseconds and converts it to Date format.
* @param: unixTime: the epoch value that is to be converted
* @return: the formated epoch time to MM/DD/YYYY
*/
const epochMStoSecondsToDate = (unixTime) => {
  //console.log("unixTime: " + unixts)
  var unixts = unixTime.slice(0, -3); // slice cuts off the last 3 digits
  //console.log("unixts: " + unixts)
  var myDate = new Date(unixts * 1000); //Converts to miliseconds
  //console.log("myDate: " + myDate)
  return (myDate.getMonth() + 1) + "/" + (myDate.getDate()) + "/" + (myDate.getFullYear())
}

/*
* Takes ISO time into date format to extact 
* from ISO to Date.toString() => Fri Jun 11 2021 16:38:57 GMT-0400 (Eastern Daylight Time)
*/
const ISOtimetoDate = (isoTime) => {
  var myDate = new Date(isoTime);
  return (myDate.getMonth() + 1) + "/" + (myDate.getDate()) + "/" + (myDate.getFullYear());
}

/*
* Func that converts epochUnixTime to LocalDate format
*@Param epochTime: the time in epoch format. <<- end of life for Epoch Time is year 2038
*@Return dateLocalDate: a fully functionable object of LocalDate that can use the pre-made functions of that component
*/
let epochTimeToLocalDate = (epochTime) => { // FOR LocalDate manual: https://js-joda.github.io/js-joda/manual/usage.html
  // epochTime FORMAT: 1570665600000

  const epochDateJSformat = new Date(epochTime) // Format: Wed Oct 09 2019 20:00:00 GMT-0400 (Eastern Daylight Time)
  console.log(epochDateJSformat)
  var LocalDate = require("@js-joda/core").LocalDate; //Defines LocalDate component (like an import)

  // +1 because getMonth starts at 0
  var dateLocalDate = LocalDate.of((epochDateJSformat.getFullYear()), (epochDateJSformat.getMonth() + 1), (epochDateJSformat.getDate()));

  //console.log(" dateLocalDate.toString(): " + dateLocalDate.toString())

  return dateLocalDate;
}

/*
*Func that iterates throgh the total or every loan or security  
* to be added together and return a Grand total of all loans or securities
*@param: JSON -> can be of the Loans or Securites
*@param: type -> to define if it is a loan or security JSON file
*@return: the total of the values added filtering out the loanStatus=PAID_OFF
*@return if TYPE = 60days: numberOf60DaysLoans-> The number of loans that are within 60 Days of today
*/
let grandTotalSum = (JSON, type) => {
  let grand_total = 0;

  if (JSON === undefined) return "undefined";
  //JSON.length by it selfs gives an error because JS finds it to be undefined
  const lengthJSON = JSON && JSON.length; // https://css-tricks.com/%E2%80%8B%E2%80%8Bavoiding-those-dang-cannot-read-property-of-undefined-errors/

  for (let i = 0; i < lengthJSON; i++) {
    if (type === "loans") {
      if (JSON[i].loanStatus === "PERFORMING") //if loanStatus is PAID_OFF filter it out of the sum
      {
        grand_total = grand_total + JSON[i].initialAmount;
      }
    } // end if Loans

    else // type = security ->>>>>>>>>>>>>>Might need revision for filters see SECURITY_STATUS_MAP
    {
      grand_total = grand_total + JSON[i].dealSize;
    } // end security else
  } // end for loop 
  return grand_total;
};

/**
 * Utils for MUI tables
 */
export const LOAN_STATUS_MAP_MUI = [
  { value: 'PERFORMING', label: 'Performing' },
  { value: 'LATE_30_DAYS', label: '30 Days Late' },
  { value: 'LATE_60_DAYS', label: '60 Days Late' },
  { value: 'LATE_90_DAYS', label: '90 Days Late' },
  { value: 'LOCKBOX_TRIGGERED', label: 'Lockbox Triggered' },
  { value: 'DEFAULT', label: 'Default' },
  { value: 'FORECLOSURE', label: 'Foreclosure' },
  { value: 'PAID_OFF', label: 'Paid Off' }
];

export const PROPERTY_TYPE_MAP_MUI = [
  { value: '', label: '' },
  { value: '', label: '' },
  { value: '', label: '' },
  { value: '', label: '' },
  { value: '', label: '' },
  { value: '', label: '' },
  { value: '', label: '' },
  { value: '', label: '' }
];


export const baseColumnOptions = { //used to carry over to the other cells
  sortable: true,
  hideable: false,
  filterable: true,
  pinnable: false, //Pro Version
  resizable: false, //Pro Version
  disableReorder: true, //Pro Version
  rowReordering: false, //Pro Version
  //minWidth: '115',
};
export const baseColumnOptionsOff = { //used to carry over to the other cells
  sortable: false,
  hideable: false,
  filterable: false,
  pinnable: false, //Pro Version
  resizable: false, //Pro Version
  disableReorder: false, //Pro Version
  rowReordering: false, //Pro Version
  //minWidth: '115',
};
const currencyFormatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
});
export const currencyColType = {
  type: 'number',
  width: 130,
  //valueFormatter: ({ value }) => value ? "$" + (value && formatCurrencyShort(value)) : "$",
  valueFormatter: ({ value }) => currencyFormatter.format(value),
  cellClassName: 'font-tabular-nums',
}

const percentageFormatter = new Intl.NumberFormat('en-US', {
  style: 'percent',
  minimumFractionDigits: 2, // Optional: Set the number of decimal places for the percentage
});
export const percentageColType = {
  type: 'number',
  width: 130,
  valueFormatter: ({ value }) => percentageFormatter.format(value / 100),
  cellClassName: 'font-tabular-nums',
}

/**
 * Utils for MUI tables
 */


/** For Calendar Component TUICalendar */

// Combined Calendar Event Categories with Colors
export const EVENT_CATEGORIES = [
  {
    id: 'Work_from_home',
    name: 'Work from Home',
    color: '#5AF489',
    keywords: [
      'work from home',
      'wfh',
      'working from home',
      'remote',
      'work remote',
      'remote work',
    ],
  },
  {
    id: 'Vacations',
    name: 'Vacations',
    color: '#8D6775',
    keywords: ['vacation', 'day off', 'day-off', 'vac', 'vacay'],
  },
  {
    id: 'Doctor_Appointment',
    name: 'Doctor Appointment',
    color: '#273EE2',
    keywords: ["doctor appointment", "doctor's appointment", "dr appointment"],
  },
  {
    id: 'Conference_room_reservation',
    name: 'Conference Room Reservation',
    color: '#6B9DB6',
    keywords: [
      'conf room reservation',
      'conference',
      'conference room',
      'meeting room',
    ],
  },
  {
    id: 'Holiday',
    name: 'Holiday',
    color: '#049968',
    keywords: ['holiday'],
  },
  {
    id: 'Sick_Day',
    name: 'Sick Day',
    color: '#F94063',
    keywords: ['sick day', 'medical day', 'sick leave', 'medical leave', 'illness', 'not feeling well'],
  },
  {
    id: 'Meeting',
    name: 'Meeting',
    color: '#EA9988',
    keywords: ['meeting', 'busy', 'unavailable', 'occupied', 'client', 'meeting client', 'lunch meeting', 'lunch',]
  },
  // Add more categories as needed
  {
    id: 'Others',
    name: 'Others',
    color: '#3A5F6B', // Default color for 'Others'
    keywords: [],
  },
];
//Available: #EA9988 #F7D4BD #91F074 #FBF4C9 #049968 #CCE8FA #B25DFC
/** For Calendar Component TUICalendar */


export const defaultImageFromBlobs ='https://korthdirect.blob.core.windows.net/2022korthdirectweb/default/nophoto.jpg?sv=2023-01-03&st=2025-05-01T18%3A51%3A03Z&se=2050-05-02T18%3A51%3A00Z&sr=b&sp=r&sig=9qco2AU%2FQ%2BHg9xTDy%2FlS3DMdRgaKa5V2MwyopLAY%2BWU%3D';



export { formatCurrency, formatCurrencyShort, formatPercentage, grandTotalSum, epochTimeToLocalDate, epochMStoSecondsToDate, inactiveHSdeals, ISOtimetoDate };